import axios from 'axios';

// filter dropdown
const filterDropdown = document.querySelectorAll('.filter-dropdown');
const faqsFilter = document.querySelector('#faqs-filter');

if (filterDropdown && faqsFilter) {
	filterDropdown.forEach((filter) => {
		let currentFilter = filter.querySelector('.filter-dropdown__current');
		let currentFilterSlug = currentFilter.getAttribute('data-slug');
		let filterItems = filter.querySelectorAll('.menu-item');
		// add selected class
		filter.querySelector(`.menu-item[data-slug="${currentFilterSlug}"]`).classList.add('selected');
		// open menu and close menu if click outside filter el
		currentFilter.addEventListener('click', (event) => {
			filter.classList.add('active');
		});
		let filterListener = function(event) {
			closeFilterDropdown(event, filter, filterListener);
		}
		document.addEventListener('click', filterListener, true);
		// update dropdown with new selected filter and close menu
		filterItems.forEach((item) => {
			item.addEventListener('click', (event) => {
				let newFilterSlug = item.getAttribute('data-slug');
				let newFilterName = item.textContent;
				currentFilter.setAttribute('data-slug', newFilterSlug);
				currentFilter.querySelector('span').textContent = newFilterName;
				filter.querySelector('.menu-item.selected').classList.remove('selected');
				document.querySelector('input[name="solution_category"]').value = newFilterSlug;
				item.classList.add('selected');
				filter.classList.remove('active');
				faqsFilterSubmit();
			});
		});
	});

	// ajax to retrieve new partner logos
	let loader = document.createElement('div');
	loader.className = 'lds-ellipsis';
	loader.appendChild(document.createElement('div'));
	loader.appendChild(document.createElement('div'));
	loader.appendChild(document.createElement('div'));
	loader.appendChild(document.createElement('div'));
	function faqsFilterSubmit() {
		let formData = new FormData(faqsFilter);
		faqsFilter.classList.add('ajaxing');
		faqsFilter.querySelector('.filter-dropdown__current').append(loader);
		formData.append('action', 'faqs_filter');
		// form ajax
		axios.post( ajaxurl, formData )
		.then( response => {
			// console.log(response);
			// remove ajax and loader
			faqsFilter.classList.remove('ajaxing');
			loader.remove();
			document.querySelector('.faqs-list').innerHTML = response.data.faqs;
			const accordionToggle = document.querySelectorAll('.accordion');
			if (accordionToggle) {
				accordionToggle.forEach((accordion) => {
					let accordionItems = accordion.querySelectorAll('.accordion__item');
					accordionItems.forEach((item) => {
						item.querySelector('.accordion__trigger').addEventListener('click', (event) => {
							event.preventDefault();
							accordionReveal(event, item, accordionItems);
						});
					});
				});
			}
		})
		.catch( error => {
			console.log(error);
			faqsFilter.classList.remove('ajaxing');
		})
	}
}

function closeFilterDropdown(event, filter, filterListener) {
	let targetEl = event.target;
	do {
		if (targetEl == filter) {
			// console.log('Clicked inside!');
			return;
		}
		// Go up the DOM
		targetEl = targetEl.parentNode;
	}
	while (targetEl);
	// console.log('Clicked outside!');
	filter.classList.remove('active');
	// document.removeEventListener('click', filterListener, true);
}

function accordionReveal(event, item, accordionItems) {
	if (event.target.classList.contains('active')) {
		event.target.classList.remove('active');
		gsapSlideUp(event.target.nextElementSibling);
	} else {
		accordionItems.forEach((item) => {
			if (item.querySelector('.accordion__trigger').classList.contains('active')) {
				item.querySelector('.accordion__trigger').classList.remove('active');
				gsapSlideUp(item.querySelector('.accordion__trigger').nextElementSibling);
			}
		});
		event.target.classList.add('active');
		gsapSlideDown(event.target.nextElementSibling);
	}
}

// animation to reveal display none content
function gsapSlideDown(el) {
	el.style.display = 'block';
	let getHeight = el.offsetHeight;
	el.removeAttribute('style');
	gsap.set(el, { display: 'block', height: 0, overflow: 'hidden' });
	gsap.to(el, { height: getHeight, clearProps: 'height,overflow' });
	el.classList.add('active');
}

// animation to hide content to display none
function gsapSlideUp(el) {
	gsap.to(el, { height: 0, overflow: 'hidden', clearProps: 'height,overflow' });
	gsap.to(el, { display: 'none' });
	el.classList.remove('active');
}
